exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".van-list__error-text,.van-list__finished-text,.van-list__loading{color:#969799;font-size:14px;line-height:50px;text-align:center}.van-list__placeholder{height:0;pointer-events:none}", "", {"version":3,"sources":["/Users/hangz/Work/projects/vision-h5/node_modules/vant/es/list/index.css"],"names":[],"mappings":"AAAA,kEAAkE,cAAc,eAAe,iBAAiB,iBAAiB,CAAC,uBAAuB,SAAS,mBAAmB,CAAC","file":"index.css","sourcesContent":[".van-list__error-text,.van-list__finished-text,.van-list__loading{color:#969799;font-size:14px;line-height:50px;text-align:center}.van-list__placeholder{height:0;pointer-events:none}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--8-1!./node_modules/vant/es/list/index.css
// module id = qR81
// module chunks = 213